import './Products.scss';
import ProductsImage from '../../../assets/ProductsHomeImage.svg';
import Heading from '../../sharedComponents/Heading/Heading';
import Button from '../../sharedComponents/Button/Button';
import { ReactComponent as ArrowForward } from '../../../assets/icons/arrow_forward.svg';
import { useNavigate } from "react-router";
function Products() {
    let navigate = useNavigate();

    const goToProductsPage = () => {
        window.scrollTo(0, 0);
        navigate("/products");
    }

    return (
        <div id='alpha-perceptron-products' className='alpha-perceptron-products'>
            <div className='alpha-perceptron-products__container'>
                <div className='alpha-perceptron-products__container__imageContainer'>
                    <img src={ProductsImage} alt='Products' />
                </div>
                <div className='alpha-perceptron-products__container__textContainer'>
                    <Heading size='h2' type='primary' theme='dark'>
                        AI-Powered Solutions
                    </Heading>
                    <Heading size='h6' type='secondary' theme='dark'>
                        From intelligent search to autonomous workflows, our AI solutions streamline operations and enhance efficiency.
                    </Heading>
                    <Button type='secondary' size='medium' icon={<ArrowForward />} onClick={goToProductsPage}>
                        View Our Products
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default Products;

